<template lang="html">

  <section class="rrss pad-sec">
    <div class="container">
      <h3 class="title title-36">{{$t('actualidad.twitter.titulo')}}</h3>
      <div class="flex wrap justify-between">  
        <tweet-el v-for="(e, key) in tweets" :data="e" :key="key"></tweet-el>
      </div>
    </div>
  </section>

</template>

<script lang="js">

  import Tweet_el from '@/components/parts/tweet-el';

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);


  export default  {
    name: 'twitter',
    props: [],
    created() {

     axios.get("tweets")
     .then(response => {
      this.tweets = response.data.tweets.splice(0,3);
    })
     .catch(error => console.log(error));

   },
   data() {
    return {
      tweets : ''
    }
  },
  methods: {

  },
  components: {
    'tweet-el' : Tweet_el,
  }
}
</script>

<style scoped>
.twitter {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/actualidad-parts/twitter.vue